import React, {useState} from 'react';
import {Formik, FormikProps} from 'formik';

import {Layouts, Button, Form} from '@components';
import {Props} from './types';
import utils from '@utils';

import * as handlers from './handlers';

import './index.scss';

const Main: React.FC<Props> = props => {
  const [reCaptchaToken, setReCaptchaToken] = useState(null);

  const initialValues = {
    email: '',
    password: '',
    confirmPassword: '',
    lastName: '',
    lastKana: '',
    firstName: '',
    firstKana: '',
    prefecture: null,
    phoneNumber: '',
    position: '',
    organization: '',
    gender: null,
    birthyear: null,
    birthmonth: null,
    birthday: null,
  };

  return (
    <div className="a__sign-up">
      <Layouts.Header.Before
        history={props.history}
        location={props.location}
        match={props.match}
      />
      <div className="w__sign-up-form">
        <div className="b__sign-up-title">新規登録</div>
        <Formik initialValues={initialValues} onSubmit={() => {}}>
          {(formProps: FormikProps<any>) => {
            return (
              <>
                <Form.SignUp
                  initialValues={initialValues}
                  submitText="新規登録"
                  handleSubmit={async (value: any, formikAction: any) => {
                    await handlers.signUpEmail(
                      value,
                      formikAction,
                      props,
                      reCaptchaToken
                    );
                  }}
                  reCaptchaToken={reCaptchaToken}
                  setReCaptchaToken={setReCaptchaToken}
                />
                <div className="w__divider">
                  <div className="b__divider" />
                  <div className="b__divider-text">または</div>
                  <div className="b__divider" />
                </div>
                <div className="w__sns-buttons">
                  <Button.SNS
                    type="google"
                    disabled={formProps.isSubmitting}
                    onClick={() => {
                      utils.auth.signInWitSNS('Google');
                    }}
                  />
                  <Button.SNS
                    type="amazon"
                    disabled={formProps.isSubmitting}
                    onClick={() => {
                      utils.auth.signInWitSNS('LoginWithAmazon');
                    }}
                  />
                  <Button.SNS
                    type="facebook"
                    disabled={formProps.isSubmitting}
                    onClick={() => {
                      utils.auth.signInWitSNS('Facebook');
                    }}
                  />
                </div>
              </>
            );
          }}
        </Formik>
      </div>
      <Layouts.Footer.Main />
    </div>
  );
};

export default Main;
